import { render, staticRenderFns } from "./work_item_state_badge.vue?vue&type=template&id=2de2190c"
import script from "./work_item_state_badge.vue?vue&type=script&lang=js"
export * from "./work_item_state_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports